export default __webpack_public_path__ + "static/media/certificateSignature.e8b72516.png";